import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { getDefaultBaseSettingsConfigFormly } from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  defaultnternationalPhoneNumberConfigFormModel,
  getIntlTelInputSettings,
  internationalPhoneNumberFieldParseIntoSettingsFormModel,
  internationalPhoneNumberFieldUpdateFromSettingsFormModel,
} from '../international-phone-number-field-type.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class InternationalPhoneNumberFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = defaultnternationalPhoneNumberConfigFormModel;
    this.settingsFormlyForm = [
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      ...getIntlTelInputSettings(),
    ];
    this.availableValidations.push('invalidNumber', 'invalidNumberFormat');
  }

  override parseFieldConfigIntoSettingsFormModel() {
    return internationalPhoneNumberFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(
    model: any
  ): FormlyFieldConfig {
    return internationalPhoneNumberFieldUpdateFromSettingsFormModel(
      model,
      this.field
    );
  }
}
